module.exports = __webpack_public_path__ + "static/media/icon_4.470eb7cb.png";